import script from "./SelectionCriteria012.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionCriteria012.vue?vue&type=script&setup=true&lang=js"

import "./SelectionCriteria012.vue?vue&type=style&index=0&id=50dded0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50dded0a"]])

export default __exports__